import { createStyles, makeStyles } from '../styles';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        subheader: {
            padding: theme.spacing(1.5),
        },
        item: {
            padding: theme.spacing(1.5),
            display: 'flex',
            justifyContent: 'center',
        },
        listboxOption: {
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        link: {
            color: theme.palette.link.active,
            textDecoration: 'underline',
            '&hover': {
                color: theme.palette.link.hover,
            },
            '&focus': {
                color: theme.palette.link.focus,
            },
        },
    });
});
//# sourceMappingURL=ListboxDropdown.styles.js.map